import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { handleHousingDeposits, validDecimalAndLength } from '../../ModificationsUtils';

export const Private3BedroomDepositAmount = () => {
  const { control, getValues, setValue } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const { t } = useTranslation();
  const private3BedRoomDepositAmount = 'private3BedRoomDepositAmount';
  const private3BedRoomDepositAmountW: number = useWatch({ name: private3BedRoomDepositAmount });
  const handleChange = (value: string) => {
    setValue(private3BedRoomDepositAmount, value);
    const updateValues = handleHousingDeposits(getValues('deposits'), 3, value ? value : '0', 'amount');
    setValue('deposits', updateValues);
  };
  return (
    <Controller
      control={control}
      name={private3BedRoomDepositAmount}
      rules={{
        required: false,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(private3BedRoomDepositAmount) ?? ''}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              handleChange(validInput);
              onChange(validInput);
            }
          }}
          InputLabelProps={{
            shrink: private3BedRoomDepositAmountW ? true : false,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          variant="filled"
          fullWidth
          id="private3BedRoomDepositAmount"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.private3BedRoomDepositAmount')}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
